import React, { CSSProperties } from 'react';
import Image from 'next/image';
import { IFeaturedImage } from '@/shared/types/existing-brands';
import './index.less';

interface IProps {
  content: IFeaturedImage[];
  orientation?: 'vertical' | 'horizontal' | 'vertical-reverse' | 'horizontal-reverse';
  speed?: 'slow' | 'medium' | 'fast';
  style?: CSSProperties;
  containerStyle?: CSSProperties;
  priority?: boolean;
}

const CarouselItem = ({ imgUrl, imgTitle, width, height, priority = false }) => {
  return (
    <div className="carousel-card" style={{ width, height }}>
      <Image src={imgUrl} alt={imgTitle} width={width} height={height} priority={priority} />
    </div>
  );
};

const AutoplayCarousel = ({
  content,
  orientation = 'horizontal',
  speed = 'medium',
  style,
  containerStyle,
  priority,
}: IProps) => {
  const carouselItems = [...content, ...content, ...content];
  return (
    <div className="carousel-container" style={containerStyle}>
      <div className={`carousel-track ${orientation} ${speed}`} style={style}>
        {carouselItems.map((item, index) => (
          <CarouselItem
            key={`${item.link} ${index}`}
            imgUrl={item.link}
            imgTitle={item.title}
            width={item.width}
            height={item.height}
            priority={priority}
          />
        ))}
      </div>
    </div>
  );
};

export default AutoplayCarousel;
